import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DwoDiagnoseBusinessService } from 'projects/Administration/src/app/business-services/dwo-diagnose.service';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';

@Component({
  selector: 'app-sst-checklist',
  templateUrl: './sst-checklist.component.html',
  styleUrls: ['./sst-checklist.component.css']
})
export class SstChecklistComponent implements OnInit {

  SstCheckList: any;
  appointmentId: any;
  SstColors = Constant.SstColors;
  inspectionCheckList: any;
  tyreCheckList: any;
  constructor(private service: DwoDiagnoseBusinessService,
    private readonly editappointment: EditAppointmentService,
    private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
    this.appointmentId = this.editappointment.appointmentDetails.appointmentId;
    this.getSstCheckList();
  }

  getSstCheckList()
  {
    this.spinner.show();
    if (this.appointmentId != null)
    {
      this.service.getSstCheckList(this.appointmentId).then((response) => {
        this.SstCheckList = response;
        this.inspectionCheckList = this.SstCheckList.filter(item => item.inspectionType == 1);
        this.tyreCheckList = this.SstCheckList.filter(item => item.inspectionType == 2);
      }); 
    }
    this.spinner.hide();
  }
}
